export default "__VITE_ASSET__ffa98a70__"